import request from '@/utils/request'

const url = '/erp/operation-rule'

export function pageOperationRule (params) {
  return request({ url: url + '/page', method: 'get', params })
}

export function getOperationRule (id) {
  return request({ url: url + '/detail', method: 'get', params: { id } })
}

export function addOperationRule (data) {
  return request({ url: url + '/add', method: 'post', data })
}

export function editOperationRule (data) {
  return request({ url: url + '/edit', method: 'post', data })
}

export function deleteOperationRule (id) {
  return request({ url: url + '/delete', method: 'post', data: { id } })
}

export function syncOperationRule (ids) {
  return request({ url: url + '/sync', method: 'post', data: { ids } })
}
